import { Link } from "react-router-dom";
import "./Landing.css";

const INVITE_EMAIL = "invites@ondetatu.com";

export function Landing() {
  return (
    <main className="landing">
      <nav className="landing__nav">
        <span className="brand">
          <img src="/tatu.svg" alt="" aria-hidden="true" />
          Ondetatu
        </span>
        <span className="landing__invite-pill">Invite only</span>
      </nav>

      <section className="landing__hero">
        <h1 className="landing__question">
          Onde <span className="accent">tá tu?</span>
        </h1>
        <p className="landing__sub">
          A living map of where your people are, when they're free, and where they're going. For
          your scattered, global circle — not the whole world.
        </p>

        <div className="landing__cta">
          <Link className="btn btn-primary" to="/login">
            I have an invite
          </Link>
          <a className="btn btn-ghost" href={`mailto:${INVITE_EMAIL}?subject=Ondetatu%20invite`}>
            Request an invite
          </a>
        </div>
        <p className="landing__note">
          You only ever see the people you've connected with — and you choose exactly what each
          circle sees.
        </p>

        <div className="landing__points">
          <div className="landing__point">
            <span className="landing__dot" style={{ background: "var(--clay)" }} />
            <span>
              <b>Presence.</b> See your friends on a map, redacted to the level you each choose.
            </span>
          </div>
          <div className="landing__point">
            <span className="landing__dot" style={{ background: "var(--teal)" }} />
            <span>
              <b>Plans.</b> Add trips; find overlapping dates and working hours across timezones.
            </span>
          </div>
          <div className="landing__point">
            <span className="landing__dot" style={{ background: "var(--amber)" }} />
            <span>
              <b>Private.</b> Mutual connections, circles, and a "still here?" map that never goes
              stale.
            </span>
          </div>
        </div>
      </section>

      <footer className="landing__footer">
        © {new Date().getFullYear()} Ondetatu · onde tá tu? · feito com carinho 🦫
      </footer>
    </main>
  );
}
